import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionHeading: {
		id: 'fastshift.organization-details.dc-instances.heading',
		defaultMessage: 'Data Center instances',
		description: 'Heading above the Data Center instances table for an organization.',
	},
	tableCaption: {
		id: 'fastshift.organization-details.dc-instances.table-caption',
		defaultMessage: 'Data Center instances connected to this organization',
		description: 'Accessible caption for the organization Data Center instances table.',
	},
	sourceColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.source-column-heading',
		defaultMessage: 'Data Center source',
		description: 'Column heading for the Data Center instance product and URL.',
	},
	connectionColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.connection-column-heading',
		defaultMessage: 'Connection',
		description: 'Column heading for the Data Center instance connection status.',
	},
	assessmentStatusColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.assessment-status-column-heading',
		defaultMessage: 'Assessment status',
		description: 'Column heading for the Data Center instance assessment status.',
	},
	actionsColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.actions-column-heading',
		defaultMessage: 'Actions',
		description: 'Column heading for actions available for a Data Center instance.',
	},
	viewDetails: {
		id: 'fastshift.organization-details.dc-instances.view-details',
		defaultMessage: 'View details',
		description: 'Link to view the details of an eligible Data Center instance.',
	},
	errorMessage: {
		id: 'fastshift.organization-details.dc-instances.error-message',
		defaultMessage: 'We’re unable to retrieve the data about your Data Center instances.',
		description: 'Error message shown when Data Center instances cannot be loaded.',
	},
	jiraProduct: {
		id: 'fastshift.organization-details.dc-instances.product.jira',
		defaultMessage: 'Jira',
		description: 'Product label for a Jira Data Center instance.',
	},
	confluenceProduct: {
		id: 'fastshift.organization-details.dc-instances.product.confluence',
		defaultMessage: 'Confluence',
		description: 'Product label for a Confluence Data Center instance.',
	},
	unknownProduct: {
		id: 'fastshift.organization-details.dc-instances.product.unknown',
		defaultMessage: 'Unknown product',
		description: 'Fallback product label for an unrecognized Data Center instance product.',
	},
});
